export function conditionLabel(code: string): string {
  return code === 'N' ? 'New' : code === 'C' ? 'Certified' : 'Used';
}

export function conditionClass(code: string): string {
  return code === 'C' ? 'certified' : '';
}

// Simple amortization: 6.9% APR default
export function calcMonthly(price: number, term = 72, down = 0, aprPct = 6.9): number {
  const principal = Math.max(0, price - down);
  if (!principal || !term) return 0;
  const r = aprPct / 100 / 12;
  return Math.round(principal * r / (1 - Math.pow(1 + r, -term)));
}

export function formatPrice(n: number): string {
  return '$' + Math.round(n).toLocaleString();
}

export function formatMiles(miles: number, condition: string): string | null {
  if (condition === 'N' || miles < 100) return null;
  return miles.toLocaleString() + ' mi';
}
